import React, {useContext} from 'react';
import {FormCustomTabContentWrapperProps} from '@src/@types/components/Form';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {OrderCommentsList} from '@views/orders/fields/comments/OrderCommentsField';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import usePermissionGranted from '@src/hooks/usePermissionGranted';
import OrderDeadlineCalendar from '@views/orders/OrderDeadlineCalendar';
import OrderProductDetails from '@views/orders/fields/products/extra_row/OrderProductDetails';
import ManagerField from '@views/orders/fields/ManagerField';
import ClientField from '@views/orders/fields/ClientField';

export default function OrderFormMainTabContentWrapper(props: FormCustomTabContentWrapperProps<IOrderModel>) {
    const [{fieldsAreDisabled}] = useContext(FormFieldDesignContext);

    const canSeeComments = usePermissionGranted('orders@can-see-comments') && props.context === 'update';

    return <div className="row">
        <div className="col-sm-6 col-md-4">{props.children}</div>
        {canSeeComments ? <div className="col">
            <OrderCommentsList
                    model={props.model}
                    forceDisabled={fieldsAreDisabled}
                    formName={props.formName}
                    maxHeight={1000}
            />
        </div> : null}
        <div className="col flex-grow-0">
            <OrderProductDetails
                    model={props.model}
                    modelOptions={props.modelOptions}
                    managerSlot={<ManagerField/>}
                    clientSlot={<ClientField/>}
                    withoutShiftOfTop
            />
            <OrderDeadlineCalendar/>
        </div>
    </div>;
}
